import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./routes/PrivateRoute";
import MainLayout from "./layouts/MainLayout";
import Login from "./pages/login/Login";
import Dashboard from "./pages/dashboard";
import Users from "./pages/users";
import Staff from "./pages/staff";
import Bundle from "./pages/bundle";
import Room from "./pages/room";
import Schedule from "./pages/schedule";
import Banner from "./pages/banner";
import Role from "./pages/role";

export default function App() {
  useEffect(() => {
    import("bootstrap/dist/js/bootstrap.bundle.min.js");
  }, []);

  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<Login />} />
      {/* Private */}
      <Route
        path="/"
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        {/* <Route index element={<Navigate to="/dashboard" replace />} /> */}
        <Route index element={<Navigate to="/schedule" replace />} />
        {/* --- DASHBOARD --- */}
        {/* <Route path="dashboard" element={<Dashboard />} /> */}
        {/* --- LESSON --- */}
        <Route path="room" element={<Room />} />
        <Route path="schedule" element={<Schedule />} />
        <Route path="bundle" element={<Bundle />} />
        <Route path="banner" element={<Banner />} />
        {/* --- USERS --- */}
        <Route path="user" element={<Users />} />
        {/* --- STAFF --- */}
        <Route path="staff" element={<Staff />} />
        <Route path="role" element={<Role />} />
      </Route>
    </Routes>
  );
}
